export default __webpack_public_path__ + "static/media/doc.07d54f94.svg";